import React, { useState } from 'react';
import { Button } from 'reactstrap';
import AddNewService from './AddNewService';

export default function ServiceFormButton({
    id, isHostedPage, isServiceOrder, allAddonCategoryData, allMembershipGroupData, LoadData, languageCode
}) {
    const [isUpdating, setIsUpdating] = useState(false);

    return (
        <div>
            <Button
                color="primary"
                size="xs"
                onClick={() => setIsUpdating(!isUpdating)}
            >
                Edit
            </Button>
            {isUpdating && (
                <AddNewService
                    id={id}
                    toggleModal={() => {
                        setIsUpdating(!isUpdating);
                    }}
                    formLabel="Edit"
                    visible={isUpdating}
                    isHostedPage={isHostedPage}
                    isServiceOrder={isServiceOrder}
                    allAddonCategoryData={allAddonCategoryData}
                    allMembershipGroupData={allMembershipGroupData}
                    LoadData={LoadData}
                    languageCode={languageCode}
                />
            )}
        </div>
    );
}

